var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInbox = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.834 10c0-.46.373-.833.833-.833h5c.279 0 .54.139.694.37l1.419 2.13h2.441l1.42-2.13a.833.833 0 0 1 .693-.37h5a.833.833 0 0 1 0 1.666H13.78l-1.42 2.13a.833.833 0 0 1-.693.37H8.334a.833.833 0 0 1-.693-.37l-1.42-2.13H1.667A.833.833 0 0 1 .834 10Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.034 2.5h7.933a2.502 2.502 0 0 1 2.238 1.386v.002l2.874 5.739a.833.833 0 0 1 .088.373v5a2.5 2.5 0 0 1-2.5 2.5H3.334a2.5 2.5 0 0 1-2.5-2.5v-5c0-.13.03-.257.088-.373l2.874-5.74A2.5 2.5 0 0 1 6.035 2.5ZM4.542 4.258l.745.373-2.786 5.566V15a.833.833 0 0 0 .833.833h13.333a.834.834 0 0 0 .834-.833v-4.803l-2.787-5.566-.001-.002a.833.833 0 0 0-.746-.462H6.034a.833.833 0 0 0-.745.462l-.747-.37Z",
  clipRule: "evenodd"
})));
SvgInbox.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgInbox);
export default ForwardRef;